import {
  ApiDataSourceSpec,
  apiDataSource,
} from '@/io/datasource/ApiDatasource';
import {
  CreateNurseNotice,
  DeleteNurseNotice,
  MitigateNurseNotice,
  NurseNotice,
  nurseNoticeSchema,
} from '@/models/NurseNoticeModel';
import { cz } from '@/utils/zodUtils';

export class ObservationsRepository {
  constructor(private readonly datasource: ApiDataSourceSpec = apiDataSource) {}

  /*
  For nurse only
   */
  createNotice = (data: CreateNurseNotice): Promise<undefined> => {
    return this.datasource.post(
      `practitioner/nurse-notice/${data.patient_id}/`,
      cz.ignore(),
      {},
    );
  };

  /*
  For nurse only
   */
  deleteNotice = (data: DeleteNurseNotice): Promise<undefined> => {
    return this.datasource.delete(
      `practitioner/nurse-notice/${data.patient_id}/${data.id}/`,
      cz.ignore(),
    );
  };

  /*
  For doctor only
  Currently same as deleteNotice. Might change in the future.
   */
  mitigateNotice = (data: MitigateNurseNotice): Promise<undefined> => {
    return this.datasource.put(
      `practitioner/nurse-notice/${data.patient_id}/${data.id}/`,
      cz.ignore(),
    );
  };

  getNurseNotice = (patientId: string): Promise<NurseNotice | null> => {
    return this.datasource.get(
      `practitioner/nurse-notice/${patientId}/`,
      cz.noContent(nurseNoticeSchema),
    );
  };
}
